import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { HelmetProvider } from 'react-helmet-async';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Cart } from './components/Cart';
import { HomePage } from './pages/HomePage';
import { NewProductsPage } from './pages/NewProductsPage';
import { ProductsPage } from './pages/ProductsPage';
import { ProductDetailPage } from './pages/ProductDetailPage';
import { CategoriesPage } from './pages/CategoriesPage';
import { CategoryPage } from './pages/CategoryPage';
import { SalePage } from './pages/SalePage';
import { SearchPage } from './pages/SearchPage';
import { CheckoutPage } from './pages/CheckoutPage';
import { OrderConfirmationPage } from './pages/OrderConfirmationPage';
import { FrenchFilterConfigPage } from './pages/FrenchFilterConfigPage';
import { TestPage } from './pages/TestPage';
import PointsDeVentePage from './pages/PointsDeVentePage';
import NotreHistoirePage from './pages/NotreHistoirePage';
import NosEngagementsPage from './pages/NosEngagementsPage';
import OrRecyclePage from './pages/OrRecyclePage';
import BijouxSurMesurePage from './pages/BijouxSurMesurePage';
import ContactPage from './pages/ContactPage';
import JournalPage from './pages/JournalPage';
import BlogPostPage from './pages/BlogPostPage';
import './index.css';

// Créer un client React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});

function App() {
  return (
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <Router>
        <div className="min-h-screen bg-gray-50 flex flex-col">
          <Header />
          <Cart />
          
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/nouveautes-bijoux-aupiho-joaillerie" element={<NewProductsPage />} />
              <Route path="/products" element={<ProductsPage />} />
              <Route path="/products/:slug" element={<ProductDetailPage />} />
              <Route path="/categories" element={<CategoriesPage />} />
              <Route path="/category/:slug" element={<CategoryPage />} />
              <Route path="/points-de-vente" element={<PointsDeVentePage />} />
              <Route path="/notre-histoire" element={<NotreHistoirePage />} />
              <Route path="/nos-engagements-aupiho-joaillerie" element={<NosEngagementsPage />} />
              <Route path="/or-recycle" element={<OrRecyclePage />} />
              <Route path="/bijoux-sur-mesure" element={<BijouxSurMesurePage />} />
              <Route path="/contactez-nous" element={<ContactPage />} />
              <Route path="/journal" element={<JournalPage />} />
              <Route path="/blog/:slug" element={<BlogPostPage />} />
              <Route path="/sale" element={<SalePage />} />
              <Route path="/search" element={<SearchPage />} />
              <Route path="/checkout" element={<CheckoutPage />} />
              <Route path="/order-confirmation/:orderId" element={<OrderConfirmationPage />} />
              <Route path="/french-filter-config" element={<FrenchFilterConfigPage />} />
              <Route path="/test" element={<TestPage />} />
            </Routes>
          </main>
          
          <Footer />
        </div>
        </Router>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </HelmetProvider>
  );
}

export default App;
